<owl-carousel-o [options]="customOptions" (changed)="onCarouselChange($event)">

  <ng-container *ngFor="let slide of carouselInfo" >
    <ng-template carouselSlide>
      <div class="owl-carousel">
        <img [attr.srcset]="slide.imageForMobileUrl + ' 768w, ' + slide.imageForPcUrl + ' 1024w'"
             sizes="(max-width: 768px) 100vw, 1024px"
             [src]="slide.imageForPcUrl">

        <div class="text-carousel">
        <span class="payment-title">{{slide?.title}}</span>
        <span class="sub-text-carousel">{{slide.shortDescription}}</span>
          <a href="https://pobeda.onf.ru/" class="button">ПОДДЕРЖАТЬ</a>
        </div>
      </div>
    </ng-template>
  </ng-container>

</owl-carousel-o>

<div class="navi-bth">
  <div *ngFor="let slide of carouselInfo | slice:currentIndex:currentIndex + 3; let i = index"
       class="line-bth"
       [ngClass]="{'active': i + currentIndex === activeIndex}"
       (click)="setActiveIndex(i + currentIndex)">
  </div>
</div>

